import Image from "next/image";
import Link from "next/link";

import { useAppContext } from "@/context/Context";
import PriceLabel from "@/components/Labels/PriceLabel";
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge";

const CourseTab = ({ course, start, end }) => {
  const { toggle } = useAppContext();

  return (
    <>
      <div
        className={`rbt-course-grid-column ${!toggle ? "active-list-view" : ""
          }`}
      >
        {course.slice(start, end).map((data, index) => (
          <div className="course-grid-3" key={index}>
            <div
              className={`rbt-card variation-01 rbt-hover ${!toggle ? "card-list-2" : ""
                }`}
            >
              <div className="rbt-card-img">
                <Link href={`/course/${data.content_id}`}>
                  <Image
                    className="h-100"
                    src={data.image.thumbnail}
                    width={362}
                    height={448}
                    alt="Card image"
                  />
                  <div className="rbt-badge-3 bg-white">
                    {data.price && data.price > 0 &&
                      <>
                        <span>-{data.offPrice}%</span>
                        <span>Off</span>
                      </>
                    }
                    {data.price && data.price <= 0 &&
                      <>
                        <span>FREE</span>
                      </>
                    }
                  </div>
                </Link>
              </div>
              <div className="rbt-card-body">
                <div className="rbt-card-top">
                  <div className="rbt-review">
                    <div className="rating">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                    <span className="rating-count">
                      ({data.review} Reviews)
                    </span>
                  </div>
                  <div className="rbt-bookmark-btn">
                    <Link className="rbt-round-btn" title="Bookmark" href="#">
                      <i className="feather-bookmark"></i>
                    </Link>
                  </div>
                </div>

                <h4 className="rbt-card-title">
                  <Link href={`/course/${data.content_id}`}>
                    {data.title}
                  </Link>
                </h4>

                <ul className="rbt-meta">
                  <li>
                    <i className="feather-book"></i>
                    {data.lesson} Lessons
                  </li>
                  <li>
                    <i className="feather-users"></i>
                    {data.student} Students
                  </li>
                </ul>

                <p className="rbt-card-text">{data.desc}</p>
                {/* <div className="rbt-author-meta mb--10">
                  <div className="rbt-avater">
                    <Link href="#">
                      <Image
                        src={data.userImg}
                        width={33}
                        height={33}
                        alt="Sophia Jaymes"
                      />
                    </Link>
                  </div>
                  <div className="rbt-author-info">
                    By <Link href={`/profile/${data.content_id}`}>{data.userName}</Link>{" "}
                    In <Link href="#">{data.userCategory}</Link>
                  </div>
                </div> */}
                <div className="rbt-card-bottom">
                  <PriceLabel post={data} />
                  {/* <div className="rbt-price">
                    <span className="current-price">${data.price}</span>
                    <span className="off-price">${data.offPrice}</span>
                  </div> */}
                  <Link
                    className="rbt-btn-link"
                    href={`/course/${data.content_id}`}
                  >
                    Learn More<i className="feather-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
        <GoogleAdLarge />

      </div>
    </>
  );
};

export default CourseTab;
